import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Navbar.css";
import { useSelector } from "react-redux";
import { useMyContext } from "./MyProvider";
import { jwtDecode } from "jwt-decode";
import { ChevronDown, ChevronUp, LogIn, LogOut, Menu } from "lucide-react";
import TestApiClient from "../LoginData/TestApiClient";
import Swal from "sweetalert2";
import SessionTimerDisplay from "../login/SessionTimerDisplay";

const Navbar = ({ navbar }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const { lang } = useMyContext();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [loginUserName, setLoginUserName] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  const { getData } = TestApiClient();
  const navbarRef = useRef(null);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const token = useSelector((state) => state.auth.token);

  const handleMouseEnter = (menuId) => {
    setHoveredItem(menuId);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

const getUserDataFromToken = (token) => {
  try {
    if (token) {
      const decodedToken = jwtDecode(token);
      const role = decodedToken.roles[0].replace("ROLE_", "");
      const username = decodedToken.sub;
      return { role, username };
    }
    return null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

  useEffect(() => {
    if (token) {
      const userData = getUserDataFromToken(token);
      const getLoginUserName = async () => {
        try {
            const response = await getData(`${process.env.REACT_APP_URL}/session`);
            
        //  const response = await axios.get(`${process.env.REACT_APP_URL}/session`);
          setLoginUserName(response);
        } catch (e) {
          console.error("Failed to fetch login user name:", e);
        }
      };
      if (userData) {
        setUsername(userData.username);
        getLoginUserName();
      }
    } else {
      setUsername("");
    }
  }, [token]);

  const logoutHandler = async (e) => {
    e.preventDefault();
    setIsVisible(false);

    const result = await Swal.fire({
      title: "Logout Now",
      text: `Are you sure?`,
      icon: null,
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#ffffff",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
        popup: "custom-swal-width",
      },
    });

    if (result.isConfirmed) {
      navigate("/logout");
    }
  };

  return (
    <div className="wrapper row2">
      <Menu className="icon-toggle" onClick={() => setIsVisible(!isVisible)} />
      <nav
        id="topnav"
        ref={navbarRef}
        style={{
          display: isVisible ? "flex" : "none",
          justifyContent: "space-between",
        }}
      >
       <ul className="clear">
  
  {navbar &&
    navbar.map((nav) => (
      <li
        key={nav.menu_id}
        className="has-sub"
        onMouseEnter={() => handleMouseEnter(nav.menu_id)}
        onMouseLeave={handleMouseLeave}
      >
        {(isAuthenticated
          ? nav.loginSubMenus && nav.loginSubMenus.length > 0
          : nav.menu_list && nav.menu_list.length > 0) ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                lineHeight: "normal", // Ensure consistent line height
                padding: "10px 0px", // Match padding with other menu items
              }}
            >
              <span style={{ fontSize: "13px", color: "#ffffff" }}>
                {lang == 1 ? nav.menu_name_eng : nav.menu_name_hi}
              </span>
              {hoveredItem === nav.menu_id ? (
                <ChevronUp size={16} color="#ffffff" strokeWidth={1.25} />
              ) : (
                <ChevronDown size={16} color="#ffffff" strokeWidth={1.25} />
              )}
            </div>
            {(isAuthenticated ? nav.loginSubMenus : nav.menu_list) && (
              <ul
                style={{
                  width: "fit-content",
                  position: "absolute", // Ensure submenu appears below
                  top: "100%", // Position below the parent menu item
                  left: 0,
                  zIndex: 1000,
                }}
              >
                {(isAuthenticated ? nav.loginSubMenus : nav.menu_list).map(
                  (subMenu) => (
                    <li key={subMenu.lid}>
                      <Link
                        to={subMenu.link.replace(/\.(jsp|action)$/i, '')}
                        onClick={() => setIsVisible(false)}
                        style={{ display: "block", padding: "8px 15px" }}
                      >
                        {lang == 1 ? subMenu.name : subMenu.name_hi}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            )}
          </>
        ) : (
          <Link
            to={nav.menu_link.replace(/\.(jsp|action)$/i, '')}
            onClick={() => setIsVisible(false)}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 0px",
              color: "#ffffff",
            }}
          >
            <span>{lang == 1 ? nav.menu_name_eng : nav.menu_name_hi}</span>
          </Link>
        )}
      </li>
    ))}
</ul>
        <div style={{ display: "flex", alignItems: "center" }}>
          {isAuthenticated ? (
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                className="relative flex items-center justify-center gap-3 rounded-full cursor-pointer"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "50%",
                  cursor: "pointer",
                }}
              >
                <img
                  src="images/prof.png"
                  alt="profile_image"
                  style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                  className="w-10 h-10 rounded-full"
                />
                <span style={{ fontWeight: "bold", color: "#d2e9d2" }}>
                  {username}
                  <span style={{ position: "absolute" }}>
                    <ChevronDown size={16} color="#ffffff" strokeWidth={1.25} />
                  </span>
                </span>
                <span
                  className="absolute bottom-0 w-3 h-3 bg-teal-500 rounded-full left-8"
                  style={{
                    position: "absolute",
                    bottom: "0px",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    left: "25px",
                    backgroundColor: "green",
                  }}
                ></span>
                {isHovered && (
                  <div
                    style={{
                      position: "absolute",
                      top: "45px",
                      right: "0",
                      backgroundColor: "white",
                      color: "#333",
                      padding: "10px 15px",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      zIndex: 1000,
                      minWidth: "200px",
                    }}
                  >
                    {loginUserName?.userName && (
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "#333",
                          lineHeight: "1.6",
                        }}
                      >
                        <div>
                                                    <SessionTimerDisplay />

                          <span style={{ color: "#4a5568", fontWeight: 600 }}>
                            Username:
                          </span>{" "}
                          {loginUserName?.userName ?? ""}
                        </div>
                        {loginUserName?.user_role != 1 && (
                          <>
                            <div>
                              <span style={{ color: "#4a5568", fontWeight: 600 }}>
                                District Name:
                              </span>{" "}
                              {loginUserName?.userName ?? ""}
                            </div>
                            <div>
                              <span style={{ color: "#4a5568", fontWeight: 600 }}>
                                District Code:
                              </span>{" "}
                              {loginUserName?.dist_code ?? ""}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <Link
                to="/logout"
                onClick={logoutHandler}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  border: "1px solid gray",
                  padding: "8px",
                  backgroundColor: "#ffffff",
                  color: "#e51414",
                }}
                className="stylemenu1"
              >
                <LogOut size={16} color="red" strokeWidth={1.25} />
                <span>Logout</span>
              </Link>
            </div>
          ) : (
            <div
              align="right"
              className="stylemenu1"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80%",
                gap: "10px",
                borderRadius: "5px",
                cursor: "pointer",
                backgroundColor: "#ffffff",
                color: "black",
                
              }}
            >
              
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;